<template>

  <div id="app_footer" class="admin">

    

  </div>
  
</template>

<script>
export default{



}
</script>

<style scoped>



</style>
